"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
require("core-js/modules/es7.array.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _vuex = require("vuex");
var _axios = _interopRequireDefault(require("axios"));
var echarts = _interopRequireWildcard(require("echarts"));
var _index = require("@/utils/index");
var _homeReport = require("@/http/interface/sfe/homeReport");
var _methods = require("@/components/Store/SalesKPIRecord/methods");
var _headerFilter = _interopRequireDefault(require("./components/headerFilter.vue"));
var _headerMore = _interopRequireDefault(require("./components/headerMore.vue"));
var _mixBoard = _interopRequireDefault(require("./components/mixBoard.vue"));
var _targetByOrder = _interopRequireDefault(require("./components/targetByOrder.vue"));
var _shop = _interopRequireDefault(require("./components/shop.vue"));
var _saleTextBoard = _interopRequireDefault(require("./components/saleTextBoard.vue"));
var _integralTextBoard = _interopRequireDefault(require("./components/integralTextBoard.vue"));
var _moneyTextBoard = _interopRequireDefault(require("./components/moneyTextBoard.vue"));
var _TargetBoard = _interopRequireDefault(require("./components/TargetBoard.vue"));
var _TargetValue = _interopRequireDefault(require("./components/TargetValue.vue"));
var _index2 = _interopRequireDefault(require("@/components/Common/Model/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var mapObj = new Map();
mapObj.set('1', curDateTree.month);
mapObj.set('2', curDateTree.quarter);
mapObj.set('3', curDateTree.year);
var _default = exports.default = {
  name: 'HomeAsm',
  components: {
    Model: _index2.default,
    HeaderFilter: _headerFilter.default,
    HeaderMore: _headerMore.default,
    MixBoard: _mixBoard.default,
    TargetByOrder: _targetByOrder.default,
    Shop: _shop.default,
    SaleTextBoard: _saleTextBoard.default,
    TargetBoard: _TargetBoard.default,
    TargetValue: _TargetValue.default,
    IntegralTextBoard: _integralTextBoard.default,
    MoneyTextBoard: _moneyTextBoard.default
  },
  data: function data() {
    return {
      headerLabers: ['timeType', 'brand', 'time'],
      salesForm: {
        type: '1',
        // 类型 月度、季度、年度
        brand: 'GY',
        // 品牌 目前写死option，并写死一个默认值
        value: ''
      },
      saleDisplayData: {},
      // 销售表现
      saleIntegralData: {},
      // 积分
      saleMoneyData: {},
      target_EV: {},
      target_LUX: {},
      target_SUV: {},
      mixData_17: {},
      // Mix_17
      mixData_18: {},
      // Mix_18
      mixData_19: {},
      mixData_20: {},
      isSales: 'sales',
      currentType: 'CNY',
      newProductsData: [],
      // 新产品
      orderSourceApi: null,
      orderForm: {
        // 查询参数（目标-订单相关）
        month: mapObj.get('1')
      },
      orderStatus: {
        // 目标-订单相关
        salesTargetQty: 0,
        confirmedQty: 0,
        orderQty: 0
      },
      storeForm: {
        // 门店
        month: mapObj.get('1')
      },
      /** 月度拜访报告 */
      monthVisitReport: {
        visitDayQty: 0,
        visitQty: 0
      },
      storeData: {},
      // 门店
      /** echart */
      SALESChat: null,
      // TPP达成量 图表
      SALESMoneyChat: null,
      isShowModel: false,
      listLoading: false,
      total: 0,
      currPage: 1,
      limit: 10,
      reportList: [],
      // 销售报表
      storeASMData: {
        activeRateNum: 0,
        signRateNum: 0
      },
      showSalary: false,
      salary: 0,
      salaryRes: 0,
      bonusMonth: '1.5',
      lookupList: {
        BONUS_CALCULATION_MONTH_MAPPING: {}
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['homeType', 'roles', 'functions'])), {}, {
    findValueByType: function findValueByType() {
      return function (type) {
        return mapObj.get(type) || '';
      };
    },
    isSalesLeaderHome: function isSalesLeaderHome() {
      if (this.homeType === 'salesLeader_home') {
        return true;
      } else {
        return false;
      }
    },
    role: function role() {
      if (this.roles && this.roles.length) {
        return this.roles[0];
      } else {
        return '';
      }
    },
    showMoneyTab: function showMoneyTab() {
      var roles = ['RSM', 'FDM'];
      return roles.includes(this.role);
    },
    showIntegralTab: function showIntegralTab() {
      var roles = ['ASM', 'RSM'];
      return roles.includes(this.role);
    }
  }),
  watch: {
    'homeType': function homeType(val, oldVal) {
      if (val !== oldVal) {
        // 切换角色
        this.changeLoginRole();
      }
    },
    'isSales': function isSales(val, oldVal) {
      if (val !== oldVal) {
        this.SALESChat.clear();
        if (val === 'integral') {
          this.salesForm.type = '2';
          this.fetchSaleIntegralData();
        } else if (val === 'money') {
          this.fetchSaleRevenuelData();
        } else if (val === 'store') {
          this.salesForm.type = '2';
        } else {
          this.fetchSaleDisplayData();
        }
      }
    },
    'currentType': function currentType(val, oldVal) {
      if (val !== oldVal) {
        this.fetchSaleRevenuelData();
      }
    },
    'salesForm.type': {
      deep: true,
      immediate: true,
      handler: function handler(val, oldVal) {
        if (!val || val !== oldVal) {
          var value = this.findValueByType(val);
          this.salesForm.value = value;
          if (!((this.isSales === 'store' || this.isSales === 'integral') && val === '2')) {
            this.isSales = 'sales';
          }
          this.currentType = 'CNY';
        }
      }
    },
    'salesForm.brand': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          // 刷新界面
          this.refreshPage();
          // 目标-订单相关
          this.fetchgReportOrderSales();
          // 门店
          this.fetchStoreData();
        }
      }
    },
    'salesForm.value': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          // 刷新界面
          this.refreshPage();
        }
      }
    },
    'orderForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          // 目标-订单相关
          this.fetchgReportOrderSales();
        }
      }
    },
    'storeForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          // 门店
          this.fetchStoreData();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    // echart初始化
    this.SALESChat = echarts.init(document.getElementById('id_asmCompRate')); // 目标-订单相关
    this.fetchgReportOrderSales();
    // 门店
    this.fetchStoreData();
    this.refreshPage();
    this.getLookupTypeCode();
  },
  methods: {
    changeLoginRole: function changeLoginRole() {
      // 重置数据
      this.headerLabers = ['timeType', 'brand', 'time'];
      this.salesForm = {
        type: '1',
        brand: 'GY',
        value: this.findValueByType(this.salesForm.type)
      };
      this.saleDisplayData = {};
      this.saleIntegralData = {}; // 积分
      this.saleMoneyData = {};
      this.mixData_17 = {};
      this.mixData_18 = {};
      this.mixData_19 = {};
      this.mixData_20 = {};
      this.target_EV = {};
      this.target_LUX = {};
      this.target_SUV = {};
      this.sales = 'sales';
      this.currentType = 'CNY';
      this.newProductsData = [];
      this.orderSourceApi = null;
      this.orderForm = {
        month: mapObj.get('1')
      };
      this.orderStatus = {
        salesTargetQty: 0,
        confirmedQty: 0,
        orderQty: 0
      };
      this.storeForm = {
        month: mapObj.get('1')
      };
      this.storeData = {};
      // 刷新页面
      this.refreshPage();
      // 目标-订单相关
      this.fetchgReportOrderSales();
      // 门店
      this.fetchStoreData();
    },
    // 刷新界面
    refreshPage: function refreshPage() {
      // 销售表现
      this.fetchSaleDisplayData();
      // MIX
      this.fetchMixData();
      // 新产品
      this.fetchNewProductsData();
      if (this.role === 'ASM') {
        this.fetchStoreASMData();
      }
      if (this.isSales === 'money') {
        this.fetchSaleRevenuelData();
      }
      if (this.isSales === 'integral') {
        this.fetchSaleIntegralData();
      }
    },
    // 标准化百分比
    standardPercent: function standardPercent(percent) {
      if (percent > 100) {
        return 100;
      } else if (percent < 0) {
        return 0;
      }
      return percent;
    },
    fetchSaleDisplayData: function fetchSaleDisplayData() {
      var _this = this;
      // 数据更新时环形图先归零
      if (this.isSales === 'sales' && this.isSalesLeaderHome) {
        (0, _methods.drawSalesSalesLeader)(this.SALESChat, {});
      } else if (this.isSales === 'sales') {
        (0, _methods.drawMoney)(this.SALESChat, {});
      }
      (0, _homeReport.getSaleDisplayData)(this.salesForm).then(function (res) {
        _this.saleDisplayData = res.data || {};
        var salesInfo = {
          finishSalesRate: 0,
          finishLUXRate: 0,
          finishSUVRate: 0,
          finishEVRate: 0,
          finishRate: 0
        };
        // 环状图
        if (res.data.list && res.data.list.length) {
          var target_all = res.data.list.find(function (t) {
            return t.title === 'ALL';
          });
          var target_LUX = res.data.list.find(function (t) {
            return t.title === 'LUX';
          });
          var target_SUV = res.data.list.find(function (t) {
            return t.title === 'SUV';
          });
          var target_EV = res.data.list.find(function (t) {
            return t.title === 'EV';
          });
          if (target_all) {
            salesInfo.finishSalesRate = target_all.finishRate || 0;
          }
          if (target_LUX) {
            salesInfo.finishLUXRate = target_LUX.finishRate || 0;
          }
          _this.target_LUX = target_LUX || {};
          if (target_SUV) {
            salesInfo.finishSUVRate = target_SUV.finishRate || 0;
          }
          _this.target_SUV = target_SUV || {};
          if (target_EV) {
            salesInfo.finishEVRate = target_EV.finishRate || 0;
          }
          _this.target_EV = target_EV || {};
          salesInfo.finishRate = res.data.finishRate || 0;
        }
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          if (_this.isSales === 'sales' && _this.isSalesLeaderHome) {
            (0, _methods.drawSalesSalesLeader)(_this.SALESChat, salesInfo);
          } else if (_this.isSales === 'sales') {
            (0, _methods.drawMoney)(_this.SALESChat, salesInfo);
          }
        }, 500);
      });
    },
    fetchSaleIntegralData: function fetchSaleIntegralData() {
      var _this2 = this;
      (0, _methods.drawMoney)(this.SALESChat, {});
      (0, _homeReport.getSaleIntegralData)(this.salesForm).then(function (res) {
        _this2.saleIntegralData = res.data || {};
        var salesInfo = {
          finishRate: res.data.attainment || 0,
          dataValue: res.data.attainment ? (0, _index.paddingNum)(res.data.attainment) + '%' : '-%'
        };
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          (0, _methods.drawMoney)(_this2.SALESChat, salesInfo);
        }, 500);
      });
    },
    fetchSaleRevenuelData: function fetchSaleRevenuelData() {
      var _this3 = this;
      (0, _methods.drawMoney)(this.SALESChat, {});
      (0, _homeReport.getSaleRevenueData)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
        'currencyType': this.currentType
      })).then(function (res) {
        _this3.saleMoneyData = res.data || {};
        var salesInfo = {
          finishRate: res.data.attainment || 0
        };
        // 延时更新避免动画顺序有问题
        setTimeout(function () {
          (0, _methods.drawMoney)(_this3.SALESChat, salesInfo);
        }, 500);
      });
    },
    fetchMixData: function fetchMixData() {
      var _this4 = this;
      (0, _homeReport.getMixData)(this.salesForm).then(function (res) {
        var mixData = res.data || [];
        var mixData_17 = mixData.find(function (item) {
          return item.title === '17+';
        });
        var mixData_18 = mixData.find(function (item) {
          return item.title === '18+';
        });
        var mixData_19 = mixData.find(function (item) {
          return item.title === '19+';
        });
        var mixData_20 = mixData.find(function (item) {
          return item.title === '20+';
        });
        _this4.mixData_17 = mixData_17 || {};
        _this4.mixData_18 = mixData_18 || {};
        _this4.mixData_19 = mixData_19 || {};
        _this4.mixData_20 = mixData_20 || {};
      });
    },
    fetchNewProductsData: function fetchNewProductsData() {
      var _this5 = this;
      (0, _homeReport.getNewProductsData)(this.salesForm).then(function (res) {
        _this5.newProductsData = res.data || [];
      });
    },
    fetchgReportOrderSales: function fetchgReportOrderSales() {
      var _this6 = this;
      if (this.orderSourceApi) {
        this.orderSourceApi.cancel('cancel');
      }
      this.orderSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)({
        version: 2,
        brand: this.salesForm.brand
      }, this.orderForm);
      (0, _homeReport.getReportOrderSales)(params, this.orderSourceApi.token).then(function (res) {
        var data = res.data || {};
        var _ref = data || {},
          salesTargetQty = _ref.salesTargetQty,
          confirmedQty = _ref.confirmedQty,
          orderQty = _ref.orderQty;
        _this6.orderStatus = {
          salesTargetQty: salesTargetQty || 0,
          confirmedQty: confirmedQty || 0,
          orderQty: orderQty || 0
        };
      });
    },
    fetchStoreData: function fetchStoreData() {
      var _this7 = this;
      (0, _homeReport.getStoreData)(this.storeForm).then(function (res) {
        _this7.storeData = res.data || {};
      });
    },
    toMorePage: function toMorePage(from) {
      var pathMap = {
        'all': '/saleDisplayMore',
        'prodSize': '/mixMore',
        'newProdcut': '/newProductsMore'
      };
      this.$router.push({
        path: pathMap[from],
        query: (0, _objectSpread2.default)({}, this.salesForm)
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    fetchList: function fetchList() {
      var _this8 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var params = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {}
      };
      this.listLoading = true;
      (0, _homeReport.getKPIOrderSalesList)(params).then(function (res) {
        _this8.listLoading = false;
        _this8.reportList = res.data.items || [];
        _this8.total = res.data.totalCount || 0;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this8.listLoading = false;
      });
    },
    // 门店SA/Da/Training
    fetchStoreASMData: function fetchStoreASMData() {
      var _this9 = this;
      (0, _homeReport.getStoreSRDATraining)((0, _objectSpread2.default)({}, this.salesForm)).then(function (res) {
        _this9.storeASMData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
          activeRateNum: res.data.activeCount > 0 && res.data.activeTargetCount === 0 ? 100 : res.data.activeRate && parseInt(res.data.activeRate) || 0,
          activeRate: res.data.activeTargetCount === 0 ? '-' : res.data.activeRate,
          signRateNum: res.data.signingCount > 0 && res.data.signingTargetCount === 0 ? 100 : res.data.signingRate && parseInt(res.data.signingRate) || 0,
          signRate: res.data.signingTargetCount === 0 ? '-' : res.data.signingRate
        });
      });
    },
    actualCountDetail: function actualCountDetail() {
      this.currPage = 1;
      this.total = 0;
      this.reportList = [];
      this.isShowModel = true;
      this.fetchList();
    },
    clickShowSalary: function clickShowSalary() {
      this.salaryRes = 0;
      this.salary = 0;
      // this.bonusMonth = ''
      this.showSalary = !this.showSalary;
    },
    onBonusCalculation: function onBonusCalculation() {
      var _this0 = this;
      if (!this.salary || !this.bonusMonth) {
        this.$message.warning('请填写月薪');
        return;
      }
      (0, _homeReport.getBonusCalculation)({
        salary: this.salary,
        bonusMonth: this.bonusMonth
      }).then(function (res) {
        if (res.success) {
          _this0.salaryRes = res.data.bonus || 0;
        }
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this1 = this;
      var param = {
        configItemCodeList: ['BONUS_CALCULATION_MONTH']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        if (res.data) {
          _this1.lookupList = res.data || {};

          // 查找值数据转换
          for (var key in _this1.lookupList) {
            _this1.generateMapping(key, _this1.lookupList[key] || []);
          }
        }
      }).catch(function () {});
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this10 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this10.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};